import React, { useState, useEffect } from "react";

export const QuickLinks = ({ list, collectionHandle, settings }) => {
    if (!settings) return null;

    const [activeUrl, setActiveUrl] = useState<string | null>(null);

    const handleQuickLinkClick = (event, url) => {
        event.preventDefault();

        // If already active, remove the filter
        if (activeUrl === decodeURIComponent(url)) {
            setActiveUrl(null);
            window.history.pushState({}, '', window.location.origin + window.location.pathname);
            window.dispatchEvent(new CustomEvent('quicklinks', { detail: { url: null, collectionHandle } }));
            return;
        }

        window.history.pushState({}, '', window.location.origin + window.location.pathname + "?filters=" + url);

        // Dispatch quicklinks event to trigger filtering
        window.dispatchEvent(new CustomEvent('quicklinks', {detail: {url, collectionHandle}}));
    };

    useEffect(() => {
        const handleUrlChange = () => {
            const urlParams = new URLSearchParams(window.location.search);
            const filters = urlParams.get('filters');
            setActiveUrl(filters);
        };

        // Override pushState to dispatch custom event
        const originalPushState = history.pushState;
        history.pushState = function(...args) {
            originalPushState.apply(history, args);
            window.dispatchEvent(new CustomEvent('urlchange'));
        };

        window.addEventListener('popstate', handleUrlChange);
        window.addEventListener('urlchange', handleUrlChange);

        handleUrlChange();

        return () => {
            // Restore original pushState
            history.pushState = originalPushState;
            window.removeEventListener('popstate', handleUrlChange);
            window.removeEventListener('urlchange', handleUrlChange);
        };
    }, []);

    return (
        <div 
            className="w-full hide-scrollbar quicklinks-container flex flex-nowrap xl:flex-wrap justify-left xl:justify-center items-center gap-x-4 gap-y-0 py-8 overflow-x-auto xl:overflow-x-visible"
        >
            {list.map((item, index) => {
                const [name, url] = item.link.split("|");
                const isActive = activeUrl === decodeURIComponent(url);
                return (
                    <>
                        <div key={index} className="quicklinks-item">
                            <a
                                onClick={(event) => handleQuickLinkClick(event, url)}
                                className={`text-[16px] cursor-pointer whitespace-nowrap py-1 inline-block hover:decoration-current ${
                                    isActive
                                        ? "font-semibold"
                                        : ""
                                }`}
                            >
                                {name}
                            </a>
                        </div>
                        
                        {index < list.length - 1 && <span className="mx-2 text-[20px] font-light">|</span>}
                    </>
                );
            })}
        </div>
    );
  
};

export default QuickLinks;